import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { AuthService } from './auth.service';
import { StorageMap } from '@ngx-pwa/local-storage';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router, public storage: StorageMap) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    
    // if (this.authService.isLoggedIn) { 
    //   return true;
    // } else {
    //   this.storage.get('isLoggedin').subscribe((res: any) => {
    //     if (res) {
    //       return true;
    //     } else {
    //       this.router.navigate(['/auth/login']);
    //       return false;
    //     }
    //   }, err => {
    //     this.router.navigate(['/auth/login']);
    //     return false;
    //   });
    // }

    return new Promise<boolean>((resolve, reject) => {
      this.authService.checkForAuth().subscribe(res => {
        if (res) {
          resolve(true);
        } else {
          this.router.navigate(['/auth/login']);
          resolve(false); ;
        }
      }, err => {
        this.router.navigate(['/auth/login']);
        resolve(false);
      });
    });

   

    // let url: string = state.url;
    // return this.checkLogin(url);
  }

}